import { Link } from "react-router-dom";

/**
 * Catch-all 404 page. Rendered by the `path="*"` route in App.js so an
 * unknown URL shows a readable message with a way back into the app
 * instead of a blank white screen. Kept intentionally dependency-light
 * so it works whether the user is signed in or out.
 */
export default function NotFound() {
  return (
    <main
      className="min-h-[70vh] flex items-center justify-center px-6 py-20"
      data-testid="not-found-page"
    >
      <div className="max-w-md text-center">
        <p className="text-sm font-medium tracking-wide text-[hsl(var(--gold))] uppercase mb-3">
          Error 404
        </p>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight mb-4">
          Page not found
        </h1>
        <p className="text-base vp-muted leading-relaxed mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/"
            className="vp-btn vp-btn-primary"
            data-testid="not-found-home-link"
          >
            Go to Home
          </Link>
          <Link
            to="/auth/login"
            className="vp-btn vp-btn-secondary"
            data-testid="not-found-signin-link"
          >
            Sign In
          </Link>
        </div>
      </div>
    </main>
  );
}
